let device = {
    addDevice: "添加设备",
    migrate: "迁移机构",
    importDevice: "设备导入",
    importPayCode: "商户导入",
    merchantBind: "商户绑定",
    deviceDetail: "设备详情",
    pushTest: "推送播报测试",
    pushAT: "推送AT指令",
    pushSuccess: "推送成功",
    deviceCode: "设备编号",
    enterDeviceCode: "请输入设备编号",
    deviceCodeFormat: "设备编号长度为1-32位，支持字母、数字、_-",
    startDeviceCode: "开始设备编号",
    endDeviceCode: "结束设备编号",
    runningStatus: "运行状态",
    versionCode: "版本号",
    versionName: "版本名称",
    offline: "离线",
    online: "在线",
    inactive: "未激活",
    deviceStatus: "设备状态",
    merchantNo: "商户编号",
    enterMerchantNo: "请输入商户编号",
    merchantNoTooLong: "商户号太长，最大32位",
    specId: "产品标识",
    selSpecId: "请选择产品标识",
    initTime: "初始化时间",
    deviceSecret: "设备秘钥",
    enterDeviceSecret: "请输入设备秘钥",
    deviceSecretFormat: "设备秘钥最大为64位，仅允许大小写字符和数字",
    deviceTotalNumber: "设备总数",
    deviceActiveNumber: "激活数",
    deviceOnlineNumber: "在线数",
    monthDeviceTrend: "近一月设备增量趋势图",
    errorDetail: "失败详情",
    deviceImportTemplate: "设备Excel导入模板",
    payCodeImportTemplate: "商户Excel 导入模板",
    templateDownload: "1、导入模板下载",
    fileImport: "2、文件导入",
    importTip: "请按格式修改后导入",
    checkedDevice: "关联设备",
    confirmUnbind: "您确定要解绑此设备？",
    deviceOffline: "设备不在线",
    deviceInactive: "设备未激活",
    deleteConfirmTitle: "删除设备",
    migrateConfirmTitle: "设备迁移",
    deviceOfCurrentPage:'当前页的设备（{count}个）',
    deviceOfAll:'所有设备（{count}个）',
    selectDevice: "选择设备",
    deleteTips: '请选择设备！',
    deleteConfirm: '确定要删除这{count}个设备？',
    deleteConfirmCurrent: '点击确定将删除当前页选择的{count}个设备。',
    deleteConfirmAll: '点击确定将删除查询到的所有{count}个设备。',
    targetOrgunit:"迁入机构"
}

export default device
